/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, inject, Input, OnChanges, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CrudOverviewBaseComponent } from '../../../base/crud-overview-base.component';
import { AuditLog } from '../../../../../shared/models/audit/audit-log';
import { STORAGE_KEYS } from '../../../../../shared/constants/storage-keys';
import { AuditLogApiService } from '../../../../services/api/audit-log-api.service';
import { AuditLogQuery } from '../../../../../shared/models/audit/audit-log-query';
import { TimelineComponent } from '../../../common/audit/timeline/timeline.component';
import { PaginationService } from '../../../../services/pagination.service';
import { AppInsightsService } from '../../../../services/app-insights.service';

@Component({
  selector: 'app-timeline-overview',
  imports: [TimelineComponent],
  templateUrl: './timeline-overview.component.html',
  styleUrl: './timeline-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [PaginationService],
})
export class TimelineOverviewComponent extends CrudOverviewBaseComponent<AuditLog> implements OnInit, OnChanges {
  @Input() public auditLogQuery?: AuditLogQuery;

  private auditLogApi = inject(AuditLogApiService);
  private appInsightsService = inject(AppInsightsService);

  private lastQuery: AuditLogQuery = {};

  constructor() {
    super(STORAGE_KEYS.NONE);
  }

  public override ngOnInit(): void {
    super.ngOnInit();

    if (this.auditLogQuery) {
      this.lastQuery = this.auditLogQuery;
      this.fetchAuditLogs(this.lastQuery, true);
    }

    this.appInsightsService.logSidebarUsage('Timeline');
  }

  public ngOnChanges(): void {
    if (this.auditLogQuery) {
      this.lastQuery = this.auditLogQuery;
      this.fetchAuditLogs(this.lastQuery, true);
    }
  }

  public onScrollToBottom(query: AuditLogQuery): void {
    query.entityId = this.lastQuery.entityId;
    query.parentEntityId = this.lastQuery.parentEntityId;
    query.parentEndingAt = this.lastQuery.parentEndingAt;
    this.lastQuery = query;
    this.fetchAuditLogs(query, false);
  }

  protected override handleNewSelection(id: string): void {}

  protected override getFriendlyItemName(item?: AuditLog | undefined): string {
    return item?.entityName ?? 'Audit Log';
  }

  protected override configureDetailsView(item: AuditLog): void {}

  private fetchAuditLogs(query: AuditLogQuery, resetPagination: boolean): void {
    if (!this.viewHistoryDisabled) {
      this.fetchPagedData(resetPagination, (page, pageSize) => {
        query.page = page;
        query.pageSize = pageSize;
        return this.auditLogApi.getAuditLogs(query);
      });
    }
  }
}
